import { useContext, useRef, useState } from "react";
import DataContext from "../store/data-context";

const recommendationsURL = `/availability/recommendations`;

const useGetRecommendations = () => {
    const [recommendations, setRecommendations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const abortControllerRef = useRef(null);

    const { setError } = useContext(DataContext);

    const fetchRecommendations = async (inputValue) => {
        if (inputValue.length === 0) {
            setRecommendations([]);
            return;
        }
        setIsLoading(true);

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;

        try {
            const response = await fetch(`/availability/recommendations`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ input: inputValue }),
            });

            if (!response.ok) {
                if (response.status === 429) {
                    setError({
                        message: "Previše upita. Pokušajte ponovo kasnije.",
                        action: "Zatvori",
                    });
                }
                setIsLoading(false);
                throw new Error("RESPONSE NOT GOOD");
            }

            let data = await response.json();

            setRecommendations(data);
            setIsLoading(false);
            return data;
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("FETCH ABORTED");
            } else {
                setIsLoading(false);
                console.log(error);
                setError({
                    message:
                        "Usluga trenutno nije dosupna. Pokušajte ponovo kasnije.",
                    action: "Zatvori",
                });
            }
        }
    };

    return {
        recommendations,
        isLoading,
        setIsLoading,
        fetchRecommendations,
        setRecommendations,
    };
};

export default useGetRecommendations;
